module.exports = __webpack_public_path__ + "static/img/6.0999228.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/6.jpg
// module id = 0HVO
// module chunks = 12